<template>
  <div class="contents-wrapper">
    <div class="contents-header">
      <div class="nav">
        <router-link to="/"><img :src="scroll_event_homeImage" /></router-link>
      </div>
    </div>
    <div class="contents-body">
      <div class="portfolio-top" />
      <div class="title">
        <h1 id="title">Alice in Dataland</h1>
        <p id="role">Illustration<br />2018</p>
      </div>

      <div class="desc">
        <p id="desc">
          <b>Description</b><br />데이터 시각화 서비스를 위한 일러스트레이션
        </p>
        <p id="name"><b>Design:</b> Yuri Ahn</p>
      </div>
      <div class="img-contents">
        <img src="/images/portfolios/alice/01.svg" />
        <img class="mini" src="/images/portfolios/alice/02.svg" />
      </div>
    </div>
    <div class="move-btn">
      <span class="prev" @click="move('milk-ui')">
        <img src="/images/chevron-left.svg" />Previous
      </span>
      <span class="next" @click="move('mgtable')">
        Next<img src="/images/chevron-right.svg" />
      </span>
    </div>
    <div class="contents-footer">
      <span class="name">
        <img src="/images/home_full_name.svg" />
      </span>
      <span class="copyright">
        <p>2021 ⓒ ahnyuri</p>
      </span>
    </div>
  </div>
</template>

<script>
import { ScrollEventMixin } from "@/mixins/ScrollEventMixin";
export default {
  name: "DetailAlice",
  mixins: [ScrollEventMixin],
  data() {
    return {};
  },
  methods: {
    move(url) {
      this.$router.push(`/detail/${url}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/views/HomeHeader.scss";
@import "@/views/HomeFooter.scss";
.contents-body {
  // display: flex;
  // outline: 1px red dashed;
  // height: 1500px;
}
.contents-wrapper {
  overflow-x: hidden;
}
.portfolio-top {
  width: 100%;
  height: 800px;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  background-image: url("/images/portfolios/alice/top.svg");
}

.title {
  float: left;
  margin-left: 10%;
  display: inline-block;
  margin-bottom: 0;
}

.title h1 {
  color: #303133;
  margin-top: 100px;
}
.title p {
  font-size: 13px;
  line-height: 20px;
  color: #606266;
  margin-top: -5px;
}
.desc {
  float: right;
  margin-right: 10%;
  margin-top: 85px;
  margin-bottom: 100px;
  width: 550px;
  font-size: 16px;
  line-height: 26px;
  color: #606266;
  display: inline-block;
}

.img-contents img {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}

.img-contents img.mini {
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 50px;
}

.move-btn {
  cursor: pointer;
  width: 100%;
  display: inline-block;
}
.move-btn a {
  cursor: pointer;
}
.move-btn > .prev {
  color: #606266;
  margin-left: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: left;
}
.prev:hover {
  color: #303133;
}
.move-btn > .next {
  color: #606266;
  margin-right: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: right;
}
.next:hover {
  color: #303133;
}
@import "@/views/DetailZMedia.scss";
</style>
